import CocktailOffer from 'assets/icons/CocktailOffer';
import PizzaOffer from 'assets/icons/PizzaOffer';
import MainsOffer from 'assets/icons/MainsOffer';
import isWithinDateRange from 'utils/isWithinDateRange';
import FreeStarterOffer from 'assets/icons/FreeStarterOffer';
import { config } from '../config';

export type OfferNotificationInfo = {
  id: number;
  title: string;
  description: string;
  image: any;
};

const { welcomeOfferIds } = config;

export const promotions = {
  welcomeOfferIds,
  birthdayOfferIds: [2013, 2014, 2016, 2017],
  // time = + 1 hour on expected so 9 = 10am british time
  isSaleOfferPeriod: isWithinDateRange('2024-10-08T09:00:00.000Z', '2024-10-17T16:00:00.000Z'),
  isSpinTheWheelPeriod: isWithinDateRange('2024-07-29', '2024-08-02'),
  percentOffFoodOfferIds: [2337, 2338, 2339, 2346],
  amountOffFoodUKOfferIds: [2365, 2362],
  amountOffFoodROIOfferIds: [2366, 2364],
  offerIdsInWallet: [
    {
      id: 2377,
      title: 'Enjoy any pizza for £10!',
      description:
        'Big pizzas, small prices. Tuck into any pizza for just £10, Mon-Wed until 22.05.',
      image: PizzaOffer,
    },
    {
      id: 2378,
      title: 'Enjoy any pizza for £10!',
      description:
        'Big pizzas, small prices. Tuck into any pizza for just £10, Sun-Thur until 23.05.',
      image: PizzaOffer,
    },
    {
      id: 2388,
      title: 'Enjoy any pizza for £10!',
      description:
        'Big pizzas, small prices. Tuck into any pizza for just £10, Mon-Wed until 22.05.',
      image: PizzaOffer,
    },
    {
      id: 2387,
      title: 'Enjoy any pizza for £10!',
      description:
        'Big pizzas, small prices. Tuck into any pizza for just £10, Sun-Thur until 23.05.',
      image: PizzaOffer,
    },
    {
      id: 2417,
      title: 'Enjoy 50% off all main courses!',
      description:
        'Love pizza and pasta? Enjoy 50% off all main courses from Sunday to Thursday until 27th June. T&Cs apply.',
      image: MainsOffer,
    },
    {
      id: 2418,
      title: 'Enjoy 50% off all main courses!',
      description:
        'Love pizza and pasta? Enjoy 50% off all main courses from Sunday to Thursday until 27th June. T&Cs apply.',
      image: MainsOffer,
    },
    {
      id: 2384,
      title: 'Enjoy a cocktail on us!',
      description:
        'Shaken or stirred, enjoy two cocktails for the price of one, Mon-Wed until 02.10.',
      image: CocktailOffer,
    },
    {
      id: 2390,
      title: 'Enjoy a cocktail on us!',
      description:
        'Shaken or stirred, enjoy two cocktails for the price of one, Mon-Wed until 02.10.',
      image: CocktailOffer,
    },
    {
      id: 2495,
      title: 'Enjoy a Free Starter!',
      description:
        'Get a FREE Starter when a main course is purchased. Valid every day until 26.09.24. T&Cs apply.',
      image: FreeStarterOffer,
    },
    {
      id: 2482,
      title: 'Enjoy a Free Starter!',
      description:
        'Get a FREE Starter when a main course is purchased. Valid every day until 26.09.24. T&Cs apply.',
      image: FreeStarterOffer,
    },
  ],
};
